import WaterGroupForm from './components/WaterGroupForm';

const WaterGroupNewPage = () => {
  return (
    <div className="flex flex-col gap-4">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Nuevo balde de agua</h1>
        <p className="text-sm text-slate-500">
          Configurá la frecuencia con la que se cambia el agua. Después podés
          asignar las mascotas que toman de este balde.
        </p>
      </div>
      <WaterGroupForm />
    </div>
  );
};

export default WaterGroupNewPage;
